import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private themeService: ThemeService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const selectedTheme = this.themeService.getSelectedTheme();
        if (selectedTheme) {
          this.themeService.updateTheme(selectedTheme);
        }
      }
    });
  }

  mostraHeaderFooterHapvida() {
    return (this.themeService.getSelectedTheme() === '1');
  }
  mostraHeaderFooterGeneric() {
    return (this.themeService.getSelectedTheme() != '1');
  }

}
